import arModel from './ModelDataTS/AR';
import boModel from './ModelDataTS/BO';
import diModel from './ModelDataTS/DI';
import ekModel from './ModelDataTS/EK';
import gaModel from './ModelDataTS/GA';
import kjModel from './ModelDataTS/KJ';
import krModel from './ModelDataTS/KR';
import laModel from './ModelDataTS/LA';
import lrModel from './ModelDataTS/LR';
import muModel from './ModelDataTS/MU';
import ofModel from './ModelDataTS/OF';
import opModel from './ModelDataTS/OP';
import puModel from './ModelDataTS/PU';
import sysModel from './ModelDataTS/SYS';
import tiModel from './ModelDataTS/TI';

import { IClientAvenyModelType } from '../Types/ClientModelTypes';

const clientAvenyModel: IClientAvenyModelType = {
  AR: arModel,
  BO: boModel,
  DI: diModel,
  EK: ekModel,
  GA: gaModel,
  KJ: kjModel,
  KR: krModel,
  LA: laModel,
  LR: lrModel,
  MU: muModel,
  OF: ofModel,
  OP: opModel,
  PU: puModel,
  SYS: sysModel,
  TI: tiModel,
};

export default clientAvenyModel;
